<div class="flex h-full flex-row items-center justify-center">
  <div *ngIf="isRunning === true" class="relative h-9 w-9">
    <ngx-spinner
      [name]="spinnerName"
      color="#0084d1"
      bdColor="#00000000"
      size="default"
      type="ball-pulse"
      [fullScreen]="false"
      [disableAnimation]="true"
      [zIndex]="10"
    >
    </ngx-spinner>
  </div>

  <div
    *ngIf="params.data.mconfig?.select.length === 0"
    class="text-r1 flex h-8 w-8 flex-shrink-0"
    tp="No store field found for time_group with detail: {{ timeSpecDetail }}"
    placement="left"
  >
    <m-exclamation-icon></m-exclamation-icon>
  </div>

  <div
    *ngIf="
      isRunning === false && params.data.query?.status === queryStatusEnum.Error
    "
    class="text-r1 flex h-8 w-8 flex-shrink-0"
    tp="Query Error: {{ params.data.query?.lastErrorMessage }}"
    placement="left"
  >
    <m-exclamation-icon></m-exclamation-icon>
  </div>

  <div
    *ngIf="isRunning === false && !!topQueryError"
    class="flex h-8 w-8 flex-shrink-0"
    [ngClass]="{
      'text-s400': topQueryError === someRowsHaveFormulaErrors,
      'text-r1': topQueryError !== someRowsHaveFormulaErrors
    }"
    tp="{{ topQueryError }}"
    placement="left"
  >
    <m-exclamation-icon></m-exclamation-icon>
  </div>

  <div
    *ngIf="!topQueryError && isLimitReached === true"
    class="text-a500 flex h-8 w-8 flex-shrink-0"
    tp="Row limit reached ({{
      timeColumnsLimit
    }}). Therefore, the result may contain incomplete data. Change detail or reduce time filter window."
  >
    <m-exclamation-icon></m-exclamation-icon>
  </div>

  <!-- <div
    *ngIf="
      isRunning === false &&
      params.data.query?.status !== queryStatusEnum.Error &&
      !topQueryError &&
      isLimitReached === false &&
      !!params.data.mconfig &&
      params.data.mconfig.warnSelect.length > 0
    "
    class="text-p500 flex h-8 w-8 flex-shrink-0"
    tp="Warning: The selected fields [{{
      params.data.mconfig.warnSelect.join(', ')
    }}] may use unsafe aggregations and produce incorrect results"
    placement="left"
  >
    <m-exclamation-icon></m-exclamation-icon>
  </div> -->

  <!-- <div>{{ params.value }}</div> -->
</div>
